module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Circle-ac106a47f61423de4319cef82b382538.svg";